import React from 'react';
import SEO from '../components/SEO';
import '../assets/HomePage.css'; // Create this CSS file for styling

const promotions = [
  "MYVEDA 6 BOTTLE BULK DEALS SAVE $150",
  "50% OFF 15 Top Brands",
  "GET 15% OFF & FREE SHIPPING",
  "FREE STANDARD SHIPPING $70 MINIMUM SPEND"
];

const products = [
  { name: "Grass-Fed Ghee", price: "$10.00", original: "$23.99", image: "ghee.jpg" },
  { name: "Vata Body Oil", price: "$22.50", original: "$45.00", image: "vata.jpg" },
  { name: "Radiance Face Cream", price: "$55.00", image: "radiance.jpg" },
  { name: "Organic Ashwagandha", price: "$5.00", original: "$20.00", image: "ashwagandha.jpg" }
];

const categories = ["Sleep", "Stress", "Digestion", "Food & Drink", "Skincare", "Bodycare", "Aromatherapy", "Yoga & Meditation"];

const blogs = [
  { title: "Vata Body Type Explained", link: "#", summary: "Embrace balance with Ayurveda" },
  { title: "Pitta Body Type", link: "#", summary: "Balancing your Ayurvedic Dosha" },
  { title: "Kapha Body Type", link: "#", summary: "Understanding your Ayurvedic Constitution" }
];

const Haveda: React.FC = () => {
  return (
    <div className="homepage">
      <SEO
        title="Haveda - Authentic Ayurveda"
        description="Discover authentic Ayurvedic products and ancient wisdom for a balanced life. Shop by category: sleep, stress, digestion, and more."
        keywords="Ayurvedic Products, Haveda, Ayurveda Skincare, Natural Stress Relief, Digestion Help"
        type="article"
      />
      <header className="hero">
        <h1>Welcome to Haveda</h1>
        <p>Discover Authentic Ayurvedic Products and Ancient Wisdom</p>
      </header>

      <section className="promotions">
        {promotions.map((promo, i) => (
          <div key={i} className="promo-banner">{promo}</div>
        ))}
      </section>

      <section className="product-showcase">
        <h2>What's Hot & Just Arrived</h2>
        <div className="products">
          {products.map((p, i) => (
            <div key={i} className="product-card">
              <img src={`/images/${p.image}`} alt={p.name} />
              <h3>{p.name}</h3>
              <p className="price">{p.price} {p.original && <span className="original">{p.original}</span>}</p>
              <button>Add to Bag</button>
            </div>
          ))}
        </div>
      </section>

      <section className="categories">
        <h2>Shop by Category</h2>
        <ul>
          {categories.map((cat, i) => (
            <li key={i}><a href="#!">{cat}</a></li>
          ))}
        </ul>
      </section>

      <section className="blog-teasers">
        <h2>From the Haveda Blog</h2>
        {blogs.map((b, i) => (
          <div key={i} className="blog-card">
            <h3><a href="#!">{b.title}</a></h3>
            <p>{b.summary}</p>
          </div>
        ))}
      </section>

      <section className="newsletter">
        <h2>Sign up for 15% off</h2>
        <p>Subscribe to receive exclusive offers and Ayurvedic insights</p>
        <form>
          <input type="email" placeholder="Your email" />
          <button type="submit">Subscribe</button>
        </form>
      </section>

      <footer className="footer">
        <div className="footer-links">
          <div>
            <h4>About</h4>
            <ul>
              <li><a href="#!">About Us</a></li>
              <li><a href="#!">Contact</a></li>
              <li><a href="#!">Gift Cards</a></li>
            </ul>
          </div>
          <div>
            <h4>Support</h4>
            <ul>
              <li><a href="#!">Shipping</a></li>
              <li><a href="#!">Refunds & Returns</a></li>
              <li><a href="#!">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <p>© 2025. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Haveda;